import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { MetaTagService } from '@modules/core/services/meta-tag.service';
import { Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { Template } from '../../models/template';
import { TemplateStoreService } from '../services/template-store.service';

@Injectable()
export class TemplateResolver implements Resolve<Template> {

  constructor(private templateStore: TemplateStoreService, private metaService: MetaTagService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Template> {
    const idSlug = route.params.id;
    return this.templateStore.getTemplate(idSlug).pipe(
      tap((template) => {
        if(!template) {
          this.templateStore.fetchTemplate(idSlug);
        }
        if(template) {
          this.metaService.studentTemplateOGMetaTag(template);
        }
      }),
      first()
    );
  }
}
